var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-item__content--select-age"},[_c('div',{staticClass:"select-age text",on:{"click":_vm.showPicker}},[_vm._v(" "+_vm._s(_vm.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }